import { Component, OnInit, Inject, signal, computed } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SavedViewsService } from '@/app/modules/saved-views/saved-views.service';
import { Logger, LogService } from '@/app/core/services/log.service';
import { MatButtonModule } from '@angular/material/button';

export interface SaveAsDialogData {
  onSave: (reportName: string, setAsDefault: boolean) => Promise<any>;
}

@Component({
  selector: 'rdo-saved-views-filters-dialog',
  styleUrls: ['./saved-views-dialogs.component.scss'],
  template: `
    <div [id]="gridName" class="saved-views-dialog">
      <h2 mat-dialog-title class="header">
        {{ 'main.saved_views.dialogs.confirm_filters.title' | translate }}
      </h2>
      <div mat-dialog-content class="content">
        {{ text() }}
      </div>
      <div mat-dialog-actions class="actions">
        <div class="actions-left"></div>
        <div class="actions-right">
          <button mat-button class="btn" (click)="onOkClick()">Ok</button>
          <button mat-button mat-dialog-close class="btn">
            {{ 'main.core.common.cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslatePipe,
  ],
  providers: [LogService],
})
export class SavedViewsFiltersDialogComponent {
  public gridName: string = 'SavedViewsFiltersDialog';
  public text = signal('');
  private logger: Logger;

  constructor(
    private dialogRef: MatDialogRef<SavedViewsFiltersDialogComponent>,
    private translateService: TranslateService,
    private savedViewsService: SavedViewsService,
    private logService: LogService,
    @Inject(MAT_DIALOG_DATA) public data: SaveAsDialogData
  ) {
    this.logger = this.logService.getModuleLogger(
      'SavedViews',
      'SavedViewsFilterDialog'
    );
  }

  ngOnInit() {
    this.text.set(this.getText());
  }

  async onOkClick(): Promise<void> {
    this.logger.info('onOkClick  called');
    await this.savedViewsService.acceptNewView();
    this.dialogRef.close({ success: true });
  }

  private getText(): string {
    const reportName = this.savedViewsService.awaitingAcceptView();
    const result = this.translateService.instant(
      'main.saved_views.dialogs.confirm_filters.message',
      { report_name: this.savedViewsService.deserializeViewName(reportName) }
    );
    return result;
  }
}
